export default __webpack_public_path__ + "static/media/tablet_landing_page_bkgr.3f3aab31.png";